import React from "react";
import { ItemTraverser } from "../../containers/commerce";
import { Container, Row, Col } from "../../components/grid";
import {
  Heading1,
  Heading2,
  Paragraph,
  Bold,
  LinkStyled,
  List,
  Heading3,
} from "../../components/typography";
import SidemenuLayout from "../../layout/DefaultLayout/Layouts/SidemenuLayout";
import ProductView1 from "../../components/commerce/ProductViews/ProductView1";
import RowProductView from "../../components/grid/RowProductView";
import TheVideoPlayer from "../../components/TheVideoPlayer";

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="Oelglas">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading1>Fadølsglas</Heading1>
          <Paragraph>
            Hos Skafte finder du et stort udvalg af ølglas, der passer perfekt
            til dit næste event, fest eller arrangement. Her på siden finder du
            både fadølsglas, belgiske øl glas og andre ølkrus i glas. Du finder
            desuden også flere varianter af øl krus i plast samt kander og
            bærehanke. Find de rette ølglas til enhver lejlighed. Se vores store
            udvalg af ølglas nedenfor.
          </Paragraph>
          <Paragraph>
            Vi har et stort sortiment af{" "}
            <LinkStyled to="/fadoel">fadøl</LinkStyled> og du kan leje{" "}
            <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> her.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="oelglas" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Stort udvalg af plastik-ølglas og tilbehør til din fest
          </Heading2>
          <Paragraph>
            Hos Skafte finder du et bredt udvalg af ølglas i plast, ølkander og
            praktisk tilbehør, der gør det nemt at servere fadøl til din næste
            fest eller event. Uanset om du arrangerer en festival, en firmafest,
            en temafest eller en privat fest, har vi de rette løsninger til dig.
          </Paragraph>
          <Paragraph>Vores udvalg af ølglas og tilbehør:</Paragraph>
          <List>
            <li>
              Fadøls-krus 30 cl (plastik) - Perfekt til mindre serveringer af
              fadøl.
            </li>
            <li>
              Fadøls-krus 40 cl (plastik) - Ideelt til en større fadøl og
              festivalstemning.
            </li>
            <li>
              Bærehank til 5 glas - Gør det nemt at bære flere øl ad gangen til
              store arrangementer.
            </li>
            <li>
              Ølkande 2 liter - Praktisk til at servere øl til flere gæster ad
              gangen.
            </li>
            <li>
              Leje af 1-liters ølglas - Perfekt til temafester som Oktoberfest.
            </li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Ølkrus i plast</Heading2>
          <Paragraph>
            Selvom det er lækkert at drikke af rigtige ølglas, kan det
            sommetider være en besværlig affære. Fx hvis der er tale om et stort
            arrangement, en festival eller hvor folk går rundt med øllen i
            hånden. Heldigvis kan man få de velkendte fadølsglas i plast!
          </Paragraph>
          <Paragraph>
            Hos Skafte finder du to størrelser af plastik krus til øl, så du
            enten har mulighed for at vælge en bestemt størrelse øl at servere,
            eller at dine gæster kan vælge mellem en lille eller en stor fadøl.
            Vælg mellem 30 cl eller 40 cl ølglas.
          </Paragraph>
          <Paragraph>
            Vores ølkrus i plast er lavet i tyk, blød plast og er desuden
            splintfri.
          </Paragraph>
          <Paragraph>
            Hvis du holder et arrangement, hvor der ofte købes flere øl ad
            gangen, kan du med fordel også bestille bærehanke. Disse bærehanke
            er lavet i pap og har plads til 5 plastikglas. De er derfor gode til
            fester og festivaler, hvor der er lang vej mellem baren og pladsen.
          </Paragraph>
          <Paragraph>
            Vi har returret på uåbnede ruller med fadølsglas i plast.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Gør serveringen nemmere med vores tilbehør</Heading2>
          <Paragraph>
            Når du serverer fadøl, handler det ikke kun om selve ølglasset. Med
            vores bærehank til 5 glas kan gæster nemt transportere flere øl ad
            gangen, hvilket gør det hurtigere at få serveret drikkevarer, især
            til festivaler og større arrangementer. Vores ølkander på 2 liter er
            perfekte, hvis du vil servere øl til flere på én gang.
          </Paragraph>
          <Heading3>
            Lej store ølglas til din Oktoberfest eller temafest
          </Heading3>
          <Paragraph>
            Vil du skabe en autentisk Oktoberfest-stemning? Hos Skafte kan du
            leje 1-liters ølglas, så du får den ægte oplevelse uden at skulle
            investere i store mængder glas.
          </Paragraph>
          <Heading3>Bestil alt til din ølservering hos Skafte</Heading3>
          <Paragraph>
            Uanset om du har brug for fadøls-krus i plast, bærehanke, ølkander
            eller leje af store ølglas, finder du det hele hos os. Vi tilbyder
            desuden returret på uåbnede ruller med fadølsglas i plast, så du kan
            handle trygt. Bestil i dag og gør din næste fest eller event endnu
            bedre!
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} textCenter>
          <Heading2>Der er stor forskel på ølglas</Heading2>
          <Paragraph>
            Se forskellen på vores plastikglas beregnet til fadøl og almindelige
            plastikglas fra det lokale supermarked.
          </Paragraph>
        </Col>
        <Col xs={12}>
          <TheVideoPlayer url="5zCqQ9c7OoE" thumbnail="forskel-fadoelsglas" />
        </Col>
      </Row>
    </Container>
    <Container>
      <Row>
        <Col xs={12}>
          <Paragraph>
            <Bold>Producentens datablad:</Bold>
          </Paragraph>
          <Paragraph>
            <LinkStyled external to="/pdf/73835_databladMG.pdf">
              30 cl. Fadølsglas
            </LinkStyled>
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
